export default "__VITE_ASSET__DphJFE8j__"